<iboxtools *ngIf="verDetalle" [Title]="" 
            isHistory='true' 
            [enableBack]="true" 
            [DateInit]="novedadPeriodo?.desde" 
            [DateEnd]="novedadPeriodo?.hasta"
            [IsEditing]="isEditing" 
            (BackChange)="OnBackChange()" 
            [PeriodList]="novedadesPeriodosHistoryList" 
            (DeleteChange)="OnDeleteChange($event)" 
            (NewChange)="OnNewChange($event)"
            (EditChange)="OnEditChange($event)" 
            (PeriodChange)="OnPeriodChange($event)" 
            (CancelChange)="OnCancelChange($event)" 
            (SaveChange)="OnSaveChange($event)" 
            (CutChange)="OnCutChange()"
            [Permiso]="permisoEdicion"
            [CurrentPeriod]="novedadPeriodo?.id">
</iboxtools>

<app-novedades-periodo-list *ngIf="!verDetalle && !buscando" [personalId]="personalId" 
                                                             [novedadesPeriodos]="novedadesPeriodos" 
                                                             [permisoEdicion]="permisoEdicion"
                                                             (VisualizarDetalle)="OnVisualizarDetalle($event)">
</app-novedades-periodo-list>

<app-novedades-periodo-detalle #ChildNovedadPeriodoDetalle [novedadPeriodo]="novedadPeriodo" *ngIf="verDetalle" 
                            [enabledForm]="habilitarFormDetalle" 
                            [MensajeError]="MensajeError" 
                            [desdeAnterior]="desdeAnterior" 
                            [ingreso]="ingreso"
                            [anteriorRetroactividad]="anteriorRetroactividad" 
                            [grupoLiq]="gruposLiquidaciones"
                            [novedadesInvalida]="novedadesInvalida">
</app-novedades-periodo-detalle>

